module.exports = __webpack_public_path__ + "img/per_img.ef457bf1.png";